import { Button, Col, Modal, Row, Spinner, Toast } from 'react-bootstrap';

import { ItemModal } from './ItemModal';
import React from 'react';
import ReactTable from 'react-table';
import { useForm, Controller } from 'react-hook-form';
import { NewRequestData, newRequestModalDefaults, useRhfWatchHook } from '../utils';
import { useQuery } from '@apollo/client';
import { allDepartmentDropdown } from '../api';
import axios from 'axios';
import Navbar from '../../../components/Navbar';
import { useSelector } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { ErrorMessage } from '@hookform/error-message';

export const CreateRequest = () => {
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [requestedItemData, setRequestedItemData] = React.useState<any[]>([]);
  const [files, setFiles] = React.useState([]);
  const [submit, setSubmit] = React.useState(false);
  const [showModal, setShowModal] = React.useState(true);
  const [form, setForm] = React.useState('');
  const [toastVisible, setToastVisible] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('Request Submitted Successfully!');
  const [formSwitchVisible, setFormSwitchVisible] = React.useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm<NewRequestData>({
    defaultValues: {
      covidRelated: 0,
      oitStock: 0,
      attachments: '',
      requestorEmail: user.email,
      fulfillingDepartment: -1,
      requestorDepartment: -1,
    },
  });


  const watchReqDept = useRhfWatchHook(watch, 'requestorDepartment', -1);
  const watchFulDept = useRhfWatchHook(watch, 'fulfillingDepartment', -1);

  const { data } = useQuery(allDepartmentDropdown);

  const deptDropdown = () => {
    if (!data) {
      return (
        <option key={-1} value=''>
          ...
        </option>
      );
    }
    let filtered = data.readAllDepartments.filter((dept) => {
      return dept.Name.indexOf('(') === -1;
    });

    return filtered;
  };
  const subDeptDropdown = (requestor: boolean) => {
    let dept = requestor ? getValues('requestorDepartment') : getValues('fulfillingDepartment');
    if (dept && dept[0] && dept[0].Name) {
      let deptName: string = dept[0].Name;
      // let splitDept = deptName.split(' ');
      // let lastSplit = splitDept[splitDept.length - 1];
      // || subDept.Name.includes(lastSplit) --- include with value before && in return
      let subFiltered = data.readAllDepartments.filter((subDept) => {
        return subDept.Name.includes(dept[0].Abbreviation) && subDept.id !== dept[0].id && subDept.Name !== deptName;
      });
      return subFiltered;
    }
    return [
      {
        id: -1,
        Abbreviation: '',
        Name: '...',
        __typename: 'Department',
      },
    ];
  };

  const handleFileAdd = (event: any) => {
    try {
      if (event.target.files[0]) setFiles([...files, event.target.files[0]]);
      // setFiles([...files, event.target.files[0]]);
    } catch (e) {
      console.log('Error: /frontend/src/pages/Receiving/CreateRequest/index//handleFileAdd', e);
    }
  };

  const columns = [
    {
      Header: '',
      accessor: 'equipmentType',
      width: 40,
      className: 'text-center',
      Cell: ({ value, row }) => {
        let rowData = {
          ...row._original,
          id: row._index,
        };
        return <ItemModal setItems={setRequestedItemData} items={requestedItemData} item={rowData} />;
      },
    },
    {
      Header: 'Equipment Type',
      accessor: 'equipmentType',
      Cell: ({ value, row }) => {
        return row._original.equipmentType;
      },
    },
    {
      Header: 'Equipment Category',
      accessor: 'equipmentCategory',
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
    },
    {
      Header: 'Account',
      accessor: 'chargeAccount',
    },
    {
      Header: 'Notes',
      accessor: 'notes',
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: '',
      Cell: (rowdata) => {
        return (
          <a
            onClick={() => {
              requestedItemData.splice(rowdata.index, 1);
              setRequestedItemData(requestedItemData);
            }}
            href='#/'
            className='link text-info'>
            Delete
          </a>
        );
      },
    },
  ];
  const fileColumns = [
    {
      Header: 'Filename',
      accessor: 'name',
    },
    {
      Header: '',
      maxWidth: 70,
      Cell: (rowdata) => {
        return (
          <a
            onClick={() => {
              files.splice(rowdata.index, 1);
              setFiles(files);
            }}
            href='#/'
            className='link text-info'>
            Delete
          </a>
        );
      },
    },
  ];

  const onSubmit = handleSubmit(async (data) => {
    setSubmit(true);
    try {
      if (requestedItemData.length <= 0) {
        throw new Error('No items were requested. Please request an item to continue!');
      }
      const formData = new FormData();
      data.covidRelated = parseFloat(data.covidRelated) === 0 ? false : true;
      data.oitStock = parseFloat(data.oitStock) !== 0;
      data.requestorDepartment = parseFloat(data.requestorDepartment[0].id);
      data.requestorDivision = data.requestorDivision ? data.requestorDivision[0].Name : 'N/A';

      // for generic request form
      // fDepe == -1 on oit request form, hardcode
      data.fulfillingDepartment !== -1 ? (data.fulfillingDepartment = parseFloat(data.fulfillingDepartment[0].id)) : (data.fulfillingDepartment = 19);
      data.fulfillingDivision ? (data.fulfillingDivision = data.fulfillingDivision[0].Name) : (data.fulfillingDivision = 'N/A');

      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
      }
      const allData = { ...data, items: [...requestedItemData] };
      formData.append('body', JSON.stringify(allData));
      // try {
      await axios
        .post(`${(window as any)._env_.REACT_APP_SERVER}/request/create`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          setToastMessage('Request Submitted Successfully!');
          setToastVisible(true);
          setSubmit(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        });
    } catch (e) {
      setToastMessage(`Whoops! ${e}`)
      setToastVisible(true)
      setSubmit(false);
    }
  });

  const oitForm = () => {
    return (
      <>
        <Row>
          <Col sm={6}>
            <div className='m-5'>
              <h1>
                <i className='fa fa-clipboard-list text-info' /> <strong>OIT Hardware Request Form</strong>
              </h1>
            </div>
          </Col>
          <Col sm={6}>
            <Button variant='dark' onClick={() => setFormSwitchVisible(true)} className='m-5 float-right'>
              Switch to Generic form
            </Button>
          </Col>
        </Row>

        <div className='ml-5 mr-5 mb-5'>
          <form id='mainForm' onSubmit={onSubmit}>
            <div className='row justify-content-start'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Requestor Name&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorName', {
                      required: true,
                    })}
                    placeholder='Enter first and last name'
                  />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Phone Number&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorPhoneNumber', {
                      required: true,
                    })}
                  />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>E-Mail&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorEmail', {
                      required: true,
                    })}
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>County Department&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <Controller
                    control={control}
                    name='requestorDepartment'
                    rules={{ required: true, validate: (v) => v !== -1 }}
                    render={({ field: { onChange } }) => (
                      <Typeahead
                        id='requestorDepartment'
                        options={deptDropdown()}
                        placeholder='Select a department'
                        labelKey='Name'
                        clearButton
                        highlightOnlyResult
                        onChange={onChange}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name='requestorDepartment'
                    render={({ message }) => <p style={{ color: 'red' }}>Error! Try selecting an option from the dropdown</p>}
                  />
                </div>
              </div>
              {watchReqDept && (
                <div className='col-sm-4'>
                  <div className='form-group'>
                    <label>County Division</label>
                    <Controller
                      control={control}
                      name='requestorDivision'
                      render={({ field: { onChange } }) => (
                        <Typeahead
                          id='requestorDivision'
                          allowNew
                          newSelectionPrefix='Select Division: '
                          options={subDeptDropdown(true)}
                          placeholder='Select a Division'
                          emptyLabel='Type to use custom division...'
                          labelKey='Name'
                          onChange={onChange}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-9'>
                <div className='form-group'>
                  <label>Delivery Location&nbsp;&nbsp;</label>
                  <input
                    className='form-control'
                    {...register('deliveryLocation')}
                    placeholder='Address of the County location where the item(s) requested should be delivered'
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-5'>
                <div className='form-group'>
                  <label>Attachments&nbsp;&nbsp;</label>
                  <input {...register('attachments')} type='file' name='attachments' onChange={(e) => handleFileAdd(e)} />
                  {/* <Controller
                  control={control}
                  name='attachments'
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Form.Control onChange={onChange} ref={ref} onBlur={onBlur} value={value} type='file' multiple/>
                  )}
                /> */}
                </div>
              </div>
            </div>
          </form>
          {files.length !== 0 && (
            <div className='row justify-content-start mb-4'>
              <div className='col-sm-5'>
                <ReactTable showPagination={false} columns={fileColumns} data={files} pageSize={files.length} NoDataComponent={() => null} />
              </div>
            </div>
          )}
          <form id='mainForm'>
            <div className='row justify-content-start'>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Is this a COVID-19 related purchase?&nbsp;&nbsp;{<span className='text-primary'>*</span>}</label>

                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='radio'
                      value={1}
                      {...register('covidRelated', {
                        required: true,
                      })}
                    />
                    <label className='form-check-label'>Yes</label>
                  </div>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='radio'
                      defaultChecked
                      value={0}
                      {...register('covidRelated', {
                        required: true,
                      })}
                    />
                    <label className='form-check-label'>No</label>
                  </div>
                </div>
              </div>
              {user.currentRole.departmentId === 19 && (
                <div className='col-sm-4'>
                  <div className='form-group'>
                    <label>Is this an order for OIT Stock?</label>

                    <div className='form-check'>
                      <input className='form-check-input' type='radio' value={1} {...register('oitStock')} />
                      <label className='form-check-label'>Yes</label>
                    </div>
                    <div className='form-check'>
                      <input className='form-check-input' type='radio' defaultChecked value={0} {...register('oitStock')} />
                      <label className='form-check-label'>No</label>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
          <label>
            *&nbsp;If making a request with items of different types (Laptops, Desktops, etc), please click 'Add Hardware Item' and enter information
            for <strong>each</strong> item type requested.
          </label>
          <hr />
          {requestedItemData.length !== 0 && (
            <ReactTable
              resizable={false}
              columns={columns}
              showPagination={false}
              sortable={false}
              NoDataComponent={() => null}
              className='-striped -highlight'
              data={requestedItemData}
              pageSize={requestedItemData.length}
            />
          )}
          <div className='mt-1' />
          <ItemModal setItems={setRequestedItemData} items={requestedItemData} item={newRequestModalDefaults} create />
          {/* <form id='mainForm'> */}
          <hr />
          <div className='row justify-content-start'>
            <Button disabled={requestedItemData.length === 0} variant='info' type='submit' className='ml-3' form='mainForm'>
              {submit && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
              Submit
            </Button>
          </div>
          {/* </form> */}
        </div>
      </>
    );
  };

  const nonOITForm = () => {
    return (
      <>
        <Row>
          <Col sm={6}>
            <div className='m-5'>
              <h1>
                <i className='fa fa-clipboard-list text-info' /> <strong>AACO Item Request Form</strong>
              </h1>
            </div>
          </Col>
          <Col sm={6}>
            <Button variant='dark' onClick={() => setFormSwitchVisible(true)} className='m-5 float-right'>
              Switch to OIT form
            </Button>
          </Col>
        </Row>
        <div className='ml-5 mb-5 mr-5'>
          <form id='mainForm' onSubmit={onSubmit}>
            <div className='row justify-content-start'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Requestor Name&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorName', {
                      required: true,
                    })}
                    placeholder='Enter first and last name'
                  />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Phone Number&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorPhoneNumber', {
                      required: true,
                    })}
                  />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>E-Mail&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control'
                    {...register('requestorEmail', {
                      required: true,
                    })}
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Requesting County Department&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <Controller
                    control={control}
                    name='requestorDepartment'
                    rules={{
                      required: true,
                      validate: (v) => v !== -1,
                    }}
                    render={({ field: { onChange, value } }) => (
                      <Typeahead
                        id='requestorDepartment'
                        options={deptDropdown()}
                        placeholder='Select a department'
                        labelKey='Name'
                        clearButton
                        highlightOnlyResult
                        onChange={onChange}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name='requestorDepartment'
                    render={({ message }) => <p style={{ color: 'red' }}>Error! Try selecting an option from the dropdown</p>}
                  />
                </div>
              </div>

              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Fulfilling County Department</label>
                  <span className='text-primary'>*</span>
                  <Controller
                    control={control}
                    name='fulfillingDepartment'
                    rules={{ required: true, validate: (v) => v !== -1 }}
                    render={({ field: { onChange } }) => (
                      <Typeahead
                        id='fulfillingDepartment'
                        options={deptDropdown()}
                        placeholder='Select a department'
                        labelKey='Name'
                        highlightOnlyResult
                        onChange={onChange}
                        clearButton
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name='requestorDepartment'
                    render={({ message }) => <p style={{ color: 'red' }}>Error! Try selecting an option from the dropdown</p>}
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              {watchReqDept && (
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <label>Requesting County Division</label>
                    <Controller
                      control={control}
                      name='requestorDivision'
                      render={({ field: { onChange } }) => (
                        <Typeahead
                          id='requestorDivision'
                          allowNew
                          newSelectionPrefix='Select Division: '
                          emptyLabel='Type to use custom division...'
                          options={subDeptDropdown(true)}
                          placeholder='Select a Division'
                          labelKey='Name'
                          onChange={onChange}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
              {watchFulDept && (
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <label>Fullfilling County Division</label>
                    <Controller
                      control={control}
                      name='fulfillingDivision'
                      render={({ field: { onChange } }) => (
                        <Typeahead
                          id='fulfillingDivision'
                          allowNew
                          emptyLabel='Type to use custom division...'
                          newSelectionPrefix='Select Division: '
                          options={subDeptDropdown(false)}
                          placeholder='Select a Division'
                          labelKey='Name'
                          onChange={onChange}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-9'>
                <div className='form-group'>
                  <label>Delivery Location&nbsp;&nbsp;</label>
                  <input
                    className='form-control'
                    {...register('deliveryLocation')}
                    placeholder='Address of the County location where the item(s) requested should be delivered'
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-5'>
                <div className='form-group'>
                  <label>Attachments&nbsp;&nbsp;</label>
                  <input {...register('attachments')} type='file' name='attachments' onChange={(e) => handleFileAdd(e)} />
                </div>
              </div>
            </div>
          </form>
          {files.length !== 0 && (
            <div className='row justify-content-start mb-4'>
              <div className='col-sm-5'>
                <ReactTable showPagination={false} columns={fileColumns} data={files} pageSize={files.length} NoDataComponent={() => null} />
              </div>
            </div>
          )}
          <form id='mainForm'>
            <div className='row justify-content-start'>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Is this a COVID-19 related purchase?&nbsp;&nbsp;{<span className='text-primary'>*</span>}</label>

                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='radio'
                      value={1}
                      {...register('covidRelated', {
                        required: true,
                      })}
                    />
                    <label className='form-check-label'>Yes</label>
                  </div>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='radio'
                      defaultChecked
                      value={0}
                      {...register('covidRelated', {
                        required: true,
                      })}
                    />
                    <label className='form-check-label'>No</label>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <hr />
          {requestedItemData.length !== 0 && (
            <ReactTable
              resizable={false}
              columns={columns}
              showPagination={false}
              sortable={false}
              NoDataComponent={() => null}
              className='-striped -highlight'
              data={requestedItemData}
              pageSize={requestedItemData.length}
            />
          )}
          <div className='mt-1' />
          <ItemModal setItems={setRequestedItemData} items={requestedItemData} item={newRequestModalDefaults} create nonOIT />
          {/* <form id='mainForm'> */}
          <hr />
          <div className='row justify-content-start'>
            <Button disabled={requestedItemData.length === 0} variant='info' type='submit' className='ml-3' form='mainForm'>
              {submit && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
              Submit
            </Button>
          </div>
          {/* </form> */}
        </div>
      </>
    );
  };

  const handleModalClick = (type: string) => {
    setForm(type);
    setShowModal(false);
  };

  const handleFormSwitch = (decision: boolean) => {
    if (decision) {
      setRequestedItemData([]);
      setFiles([]);
      reset();
      setFormSwitchVisible(false);
      setForm(form === 'n' ? 'o' : 'n');
    }
    setFormSwitchVisible(false);
  };
  return (
    <React.Fragment>
      <Navbar />
      <Toast
        autohide
        style={{ backgroundColor: '#454545', color: '#ffffff', position: 'absolute', top: 75, right: '45%' }}
        show={toastVisible}
        onClose={() => setToastVisible(!toastVisible)}>
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
      <Modal centered size='lg' show={showModal}>
        <Modal.Header>
          <Modal.Title>Select Request Form</Modal.Title>
          <Button variant='dark' onClick={() => window.location.replace('/')}>
            <i className='fa fa-times'/>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <h5>If requesting hardware from OIT, please select 'OIT Equipment Form'.</h5>
          <h5>For inter-department requests not requiring OIT involvement, please select 'Generic Request Form'</h5>
          <h5>
            <span style={{ color: 'red' }}>*</span>Inter-department requests require the department fulfilling the request to be known.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='info' onClick={() => handleModalClick('o')}>
            OIT Equipment Form
          </Button>
          <Button variant='secondary' onClick={() => handleModalClick('n')}>
            Generic Request Form
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal backdrop='static' show={formSwitchVisible}>
        <Modal.Header>
          <Modal.Title>Switch Forms?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          All information will be <strong>lost</strong>. Are you sure you want to switch forms?
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={() => handleFormSwitch(true)} className='ml-3'>
            Yes
          </Button>
          <Button variant='secondary' onClick={() => handleFormSwitch(false)} className='ml-3'>
            No
          </Button>
        </Modal.Footer>
      </Modal>
      {form === 'o' && oitForm()}
      {form === 'n' && nonOITForm()}
      {form === '' && <div></div>}
    </React.Fragment>
  );
};
